export const SET_LANGUAJE = "SET_LANGUAJE";
export const SELECT_IMAGE = "SELECT_IMAGE";
export const CLEAR_IMAGE = "CLEAR_IMAGE";

export const SET_THEME = "SET_THEME";
